import { api, success } from "@";

// Function to save the order of pages
export const savePagesOrder = async (data) => {
  const items = data.map((el, index) => ({
    id: el.id,
    order: index,
  }));
  try {
    await api.put(`/api/AdminWebsitePages/change-order`, {
      orderPageModels: items,
    });

    success("تم الحفظ بنجاح");
  } catch (error) {}
};
